<header
    class="header"
    [class._default-height]="hideHeaderPromo()"
    [lsUiClassOnScroll]="50"
>
    <div class="header__content container">
        <button
            class="header__menu-button"
            [hasIcon]="true"
            [name]="'common.button-menu' | translate"
            lsUiButtonKind="subtle"
            lsUiButtonPalette="neutral-1"
            lsUiButtonSize="small"
            (click)="toggleMenu()"
        >
            <ls-ui-icon
                height="24"
                src="menu"
                width="24"
            />
        </button>

        <a
            class="header__logo"
            [routerLink]="'/' | localize"
            (click)="closeMenu()"
        >
            <ls-picture
                [breakpoint]="logoBreakpoint"
                [height]="58"
                [srcMobile]="'event-themes/' + eventTheme + '/images/logo-mobile'"
                [src]="'event-themes/' + eventTheme + '/images/logo-desktop'"
                [width]="isMobileLogo ? 104 : 160"
                alt="AEROBET"
            />
        </a>

        <nav class="header__nav">
            @for (link of headerLinks; track $index) {
                @if (link.url) {
                    <a
                        class="header__nav-link link _subtle-light _graphic-link-header"
                        [routerLink]="[link.url | localize]"
                        routerLinkActive="_selected"
                    >
                        {{ link.name | translate }}
                    </a>
                }
            }
        </nav>

        <div
            #uiClassOnScroll="uiClassOnScroll"
            #user="user"
            class="header__actions"
            [lsUiClassOnScroll]="500"
            lsUser
        >
            <ng-container *lsUiNgLet="user.userLoadingStatus$ | async as userLoadingStatus">
                @if (userLoadingStatus === userViewStatuses.NO_USER) {
                    <button
                        [class._themed]="eventTheme | checkEventThemePipe"
                        [lsUiButtonPalette]="(uiClassOnScroll.isScrolled && !wasLoggedIn) ? 'accent-1' : 'accent-1'"
                        [name]="'common.button-register' | translate"
                        lsUiButtonKind="primary"
                        lsUiButtonSize="small"
                        (click)="registration()"
                    >
                        {{ 'common.button-register' | translate }}
                    </button>

                    <button
                        [lsUiButtonKind]="wasLoggedIn ? 'subtle' : 'subtle'"
                        [lsUiButtonPalette]="wasLoggedIn ? 'neutral-1' : 'neutral-1'"
                        [name]="'common.button-log-in' | translate"
                        lsUiButtonSize="small"
                        (click)="login()"
                    >
                        {{ 'common.button-log-in' | translate }}
                    </button>
                }

                @if (userLoadingStatus === userViewStatuses.LOADED) {
                    <ls-profile-balance/>
                    <ls-profile [isProfilePage]="isProfilePage()"/>

                    @if (hasInboxNotifications) {
                        @defer {
                            <ls-notification-inbox/>
                        }
                    }
                }
            </ng-container>

        </div>
    </div>

    <!--    @if (!hideHeaderPromo()) {-->
    <!--        <div class="header__aviator-wrapper container">-->
    <!--            <a-->
    <!--                class="header__aviator"-->
    <!--                [routerLink]="['/game/aviator-spribe' | localize]"-->
    <!--            >-->
    <!--                <img-->
    <!--                    class="header__aviator-img"-->
    <!--                    [src]="(cdn | resolveUrlMirror) + '/images/aviator/pic.svg'"-->
    <!--                    alt="Aviator"-->
    <!--                >-->
    <!--            </a>-->
    <!--        </div>-->
    <!--    }-->
</header>
